import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../services/api";
import { useTranslation } from "../i18n";
import "./Login.css";

export default function Contact() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.sendContact(email, message);
      setSent(true);
    } catch {
      setError(t("contact.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-bg">
        <div className="login-gradient" />
      </div>

      <div className="login-container" style={{ justifyContent: "center" }}>
        <div className="login-card">
          <div className="login-header">
            <Link to="/" className="login-brand">
              <img src="/logos/mark-black-background.jpg" alt="ViewsDay" className="login-logo" />
            </Link>

            {sent ? (
              <>
                <h1 className="login-title">{t("contact.sentTitle")}</h1>
                <p className="login-subtitle">{t("contact.sentDesc")}</p>
                <div style={{ marginTop: 24 }}>
                  <Link to="/" className="link-btn">{t("contact.backHome")}</Link>
                </div>
              </>
            ) : (
              <>
                <h1 className="login-title">{t("contact.title")}</h1>
                <p className="login-subtitle">{t("contact.subtitle")}</p>
              </>
            )}
          </div>

          {!sent && (
            <form onSubmit={handleSubmit} className="login-form">
              {error && <div className="login-error">{error}</div>}

              <div className="form-group">
                <label className="form-label">{t("login.email")}</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  className="form-input"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">{t("contact.message")}</label>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder={t("contact.messagePlaceholder")}
                  className="form-input"
                  rows={5}
                  style={{ resize: "vertical" }}
                  required
                />
              </div>

              <button type="submit" className="btn-primary btn-full" disabled={loading}>
                {loading ? <span className="btn-spinner" /> : t("contact.send")}
              </button>

              <div className="login-switch">
                <Link to="/" className="link-btn">{t("contact.backHome")}</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
